import { Link } from 'react-router-dom';
import { useSettings } from '../SettingsContext';
import React, { useEffect, useState } from "react";
import axios from "axios";

const Footer = () => {
    const setting = useSettings();
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [visaTypes, setVisaTypes] = useState([]);

    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_VISA_TYPE;

        const cachedVisaTypes = localStorage.getItem("visaTypes");
        const cacheTimestamp = localStorage.getItem("visaTypesTimestamp");
        const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes

        if (cachedVisaTypes && cacheTimestamp && (Date.now() - cacheTimestamp < cacheExpiryTime)) {
            setVisaTypes(JSON.parse(cachedVisaTypes));
        } else {
            axios.get(`${apiBaseUrl}${Url}`)
                .then(response => {
                    setVisaTypes(response.data);
                    localStorage.setItem("visaTypes", JSON.stringify(response.data));
                    localStorage.setItem("visaTypesTimestamp", Date.now());
                })
                .catch(error => console.error("Error fetching API", error));
        }
    }, []);

    return (
        <footer className="footer-area footer-bg pt-5">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <div className="footer-about-1">
                            <div className="footer-about-1-content">
                                <div className="footer-logo footer-logo-3 mb-30">
                                    <Link className="footer-logo" to={'/'}>
                                        <img src={`${backendBaseUrl}${setting?.logo}`} alt="logo" style={{ width: '200px' }} />
                                    </Link>
                                </div>
                                <p className="mb-50 text-dark" align={'justify'}>It is a trusted and experienced visa consultancy firm that has been providing dedicated services for over 20 years.</p>
                                <h4 className="footer-about-1__title mb-30 text-dark">
                                    Follow Us
                                </h4>
                                <div className="social-link d-flex align-items-center gap-1">
                                    {[
                                        { key: 'facebook', icon: 'fab fa-facebook-f', label: 'Facebook', bg: '#1877F2' },
                                        { key: 'youtube', icon: 'fab fa-youtube', label: 'YouTube', bg: '#FF0000' },
                                        { key: 'instagram', icon: 'fab fa-instagram', label: 'Instagram', bg: '#E4405F' },
                                        { key: 'linkedIn', icon: 'fab fa-linkedin-in', label: 'LinkedIn', bg: '#0A66C2' },
                                        { key: 'tiktok', icon: 'fab fa-tiktok', label: 'TikTok', bg: '#000000' },
                                        { key: 'twitter', icon: 'fab fa-twitter', label: 'Twitter / X', bg: '#000000' },
                                    ].map((item) => (
                                        setting?.[item.key] && (
                                            <a
                                                key={item.key}
                                                href={setting[item.key]}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                aria-label={item.label}
                                                className="d-inline-flex align-items-center justify-content-center text-decoration-none shadow-sm"
                                                style={{
                                                    width: '38px',
                                                    height: '38px',
                                                    borderRadius: '50%',
                                                    backgroundColor: item.bg,
                                                    color: '#ffffff',
                                                    fontSize: '16px',
                                                }}
                                            >
                                                <i className={item.icon}></i>
                                            </a>
                                        )
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-lg-3">
                        <div className="footer-widget footer-2 footer-btm-mobile ml-30">
                            <h3 className="footer-widget__title mb-25">
                                QUICK LINKS
                            </h3>
                            <ul className="footer-widget_menu-link">
                                <li>
                                    <Link className="nav-link" to={'/'}><i className="far fa-angle-double-right"></i> HOME</Link>
                                </li>
                                <li>
                                    <Link className="nav-link" to={'/about-us'}><i className="far fa-angle-double-right"></i> ABOUT US</Link>
                                </li>
                                <li>
                                    <Link className="nav-link" to={'/visa'}><i className="far fa-angle-double-right"></i> VISA</Link>
                                </li>
                                <li>
                                    <Link className="nav-link" to={'/blogs'}><i className="far fa-angle-double-right"></i> NEWS & ARTICLE </Link>
                                </li>
                                <li>
                                    <Link className="nav-link" to={'/contact-us'}><i className="far fa-angle-double-right"></i> CONTACT US</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-6 col-lg-3">
                        <div className="footer-widget footer-3 footer-btm-mobile ml-50">
                            <h3 className="footer-widget__title mb-25">
                                VISA TYPE
                            </h3>
                            <ul className="footer-widget_menu-link">
                                {visaTypes.map((visaType, index) => (
                                    <li key={index}>
                                        <Link className="text-decoration-none" to={`/visa/${visaType.slug}`}><i className="far fa-angle-double-right"></i> {visaType?.name}</Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="col-6 col-lg-3">
                        <div className="footer-widget footer-4 footer-btm-mobile ml-40">
                            <h3 className="footer-widget__title mb-25">
                                GET IN TOUCH
                            </h3>
                            <ul className="footer-widget_menu-link-info">
                                <li><a className={'nav-link'} href={setting?.footer_phone || ''}><i className="far fa-phone-alt"></i> <span> {setting?.footer_phone || ''}</span></a></li>
                                <li><a className={'nav-link'} href={`mailto:${setting?.email || ''}`}><i className="fal fa-envelope"></i> <span><span className="__cf_email__" data-cfemail="e99a9c9999869b9da98e84888085c78a8684">{setting?.email || ''}</span></span></a></li>
                                <li><a className={'nav-link'} href="contact.html"><i className="fal fa-map-marker-alt"></i> <span>{setting?.address || ''}</span></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row bg-white">
                <div className="container">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-12 text-center">
                                <p className="copyright-text text-dark">
                                    {setting?.footer_copyright || ''}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
